﻿window.grideditor = function () {
    var start_r;
    var start_c;
    var value;
    var instance = {
        init: function (args) {
            var table = document.getElementById(args.clientID);
            start_r = null;
            start_c = null;
            const _this = this;
            table.querySelectorAll("td[r][c]").forEach(el => {
                el.addEventListener("mousedown", function (evt) {
                    if (evt.button == 0) {
                        start_r = parseInt(evt.target.getAttribute("r"));
                        start_c = parseInt(evt.target.getAttribute("c"));
                        value = evt.target.getAttribute("value") == "on" ? "off" : "on";
                        fillValues(table, evt.target);
                        return false;
                    }
                });
                el.addEventListener("mouseup", function (evt) {
                    if (!start_r)
                        return false;
                    start_r = null;
                    start_c = null;
                    table.querySelectorAll("td[r][c]").forEach(el => {
                        el.setAttribute("value", el.classList.contains("on") ? "on" : "off");
                    });
                    _this.fillInput(table, args.inputID);
                    return false;
                });
                el.addEventListener("mousemove", function (evt) {
                    if (!start_r)
                        return;
                    else if (evt.buttons != 1) {
                        table.querySelectorAll("td[r][c]").forEach(el => {
                            el.setAttribute("value", el.classList.contains("on") ? "on" : "off");
                        });
                        _this.fillInput(table, args.inputID);
                        start_r = null;
                        start_c = null;
                        return;
					}
                    fillValues(table, evt.target);
                    _this.fillInput(table, args.inputID);
                });
            });
            this.fillInput(table, args.inputID);
        },
        fillInput: function (table, inputName) {
            var v = "";
            table.querySelectorAll("td[r][c]").forEach(el => {
                v += el.classList.contains("on") ? "1" : "0";
            });
            document.getElementById(inputName).value = v;
        }
    };
    function fillValues(table, target) {
        var target_r = target ? parseInt(target.getAttribute("r")) : -1;
        var target_c = target ? parseInt(target.getAttribute("c")) : -1;
        table.querySelectorAll("td[r][c]").forEach(el => {
            el.classList.remove("on");
            el.classList.remove("off");            
            var r = parseInt(el.getAttribute("r"));
            var c = parseInt(el.getAttribute("c"));
            if (((start_r <= r && r <= target_r) || (target_r <= r && r <= start_r)) &&
                ((start_c <= c && c <= target_c) || (target_c <= c && c <= start_c)))
                el.classList.add(value);
            else
                el.classList.add(el.getAttribute("value"));
        });
    }
    return instance;
}();